import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';
import { IndicadoresProjeto } from '../../models/indicadores-projeto.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { IndicadoresProjetoService } from '../../services/indicadores-projeto.service';
import { NavigationService } from '../../services/navigation.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-detalhe-projeto-indicadores-somatorio-edit',
  templateUrl: './detalhe-projeto-indicadores-somatorio-edit.component.html',
  styleUrls: ['./detalhe-projeto-indicadores-somatorio-edit.component.scss']
})
export class DetalheProjetoIndicadoresSomatorioEditComponent extends BaseFormComponent<IndicadoresProjeto> implements OnInit {

  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  audit: AtualizacoesAudit;

  constructor(
    private myService: IndicadoresProjetoService,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
    });

    this.entity.summed.forEach(indicador => {
      if (indicador?.value?.length && this.entity?.checkedSummed?.length) {
        indicador.value.forEach((item) => {
          item.check = this.entity?.checkedSummed.includes(item.id);
        });

        const allItemsChecked = indicador.value.every(item => item?.check);
        if (allItemsChecked) {
          indicador.check = true;
        }
      }
    });

    this.audit = {
      ind_id: this.entity.id
    };

    this.loaded();
  }

  selectAll(event: boolean, summed) {
    summed.check = event;
    this.entity.summed.forEach(indicador => {
      if (indicador?.value?.length) {
        indicador.value.forEach((item) => {
          if (summed.name == indicador.name) {
            item.check = event;
          }
        })
      }
    });
  }

  changeselectAll() {
    this.entity.summed.forEach(indicador => {
      if (indicador?.value?.length) {
        indicador.check = indicador.value.every(item => item?.check);
      }
    });
  }

  getDataCreate() {
    const listChecked = this.entity.summed
      .flatMap(indicador => indicador?.value ? indicador.value : [])
      .filter(item => item.check)
      .map(item => item.id);

    return {
      pf_ind_sum: {
        ind_id: listChecked,
      },
    };
  }

  salvar(): void {
    this.loading();
    
    if (this.entity?.id) {
      this.addSub(
        this.myService.updateSomados(this.getDataCreate(), this.entity?.id).subscribe({
          next: (res) => {
            this.msgSuccess('Indicadores Somandos alterados com sucesso!')
            EventSharedService.get('auditRefresh').emit();
            this.loaded();
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          },
        })
      );
    }
  }

  voltar() {
    if (this.entity?.id) {
      this.navigation.back(['projetos', 'projeto', this.idProjeto, 'indicadores', this.entity?.id]);
    } else {
      this.navigation.back(['projetos', 'projeto', this.idProjeto, 'indicadores']);
    }
  }

}
